import { TableCard } from '../../../../components'
import { ListViewProvider } from './core/ListViewProvider'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { PacientesListHeader } from './components/header/PacientesListHeader'
import { PacientesTable } from './table/PacientesTable'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'

const PacienteList = () => {
  return (
    <TableCard>
      <PacientesListHeader />
      <PacientesTable />
    </TableCard>
  )
}

export const PacientesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <PacienteList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
